import $ from 'jquery'
import store_config from '@/store/mods/parametres/config'

export default {
    name: 'acces-examens',
    components: {},
    props: [],
    data() {
        return {
            is_empty: false,
            is_loading: true,
            btn_disable: false,
            save_loading: false,

            fields: [
                { key: 'nom_prenom', label: 'Nom & Prénom.s' }, { key: 'titre', label: 'Titre' },
                { key: 'examens', label: 'Examen.s' }
            ],
            filter: "",
            perPage: 10,
            currentPage: 1,

            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
            text_grey: [],

            selected_user: {
                id: 0,
                nom: ''
            },
            liste_user_acces_to_examens: []
        }
    },
    computed: {
        types_examens() {
            return this.$store.getters["examens"];
        },
    },
    mounted() {
        this.$store.dispatch("getExamens")

        this.refreshUserAccess()
    },
    methods: {
        async refreshUserAccess() {
            this.is_loading = true
            await store_config.getRolePersonnels().then(async(response) => {
                const personnels = response

                const data = {
                    data_type: 'type_examen',
                    personnels: personnels
                }
                await store_config.getListeAccessToPrestation(data).then((response) => {
                    this.liste_user_acces_to_examens = response.data

                    if (this.liste_user_acces_to_examens.length > 0) {
                        this.is_empty = false 
                    } else {
                        this.is_empty = true
                    }
                })
                
                this.is_loading = false
            })
        },

        toutSelectionner() {
            let is_checked = $('#consult-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.types_examens.forEach((data) => {
                    
                    this.text_grey[i] = 'text-grey'

                    this.one_is_checked.push(data.id)

                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.types_examens.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            let is_checked = $('#consult'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c

            document.getElementById("consult-tous").checked = false;
        },
        
        edit(data) {
            this.one_is_checked = []
            this.text_grey = []

            this.selected_user.nom = data.nom
            this.selected_user.id = data.id

            data.accessibilites.forEach((acess_el) => {
                this.types_examens.forEach((el) => {

                    if (acess_el.data_id == el.id) {
                        this.text_grey[el.id] = 'text-grey'
    
                        this.one_is_checked.push(el.id)
                    }
                    
                });
            })
        },

        submit() {
            this.save_loading = true;
            this.btn_disable = true

            let data = {
                data_type: 'type_examen',
                user_id: this.selected_user.id,
                accessibilites: this.one_is_checked
            }

            this.$store.dispatch('saveConsultationAccessibilite', data).then((response) => {
                if (response >= 0) {
                    this.successMsg("Les examens ont été assignés à l'utilisateur avec succès !")
                    this.$refs.modal_acces.click()
                    this.refreshUserAccess()
                } 

                this.save_loading = false;
                this.btn_disable = false
            })
        }, 

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },
    }
}